import { useTheme } from '@mui/material';
import { Label } from '@/components';
import { InvoiceDryRunStatus } from '../types';

type Props = {
  status?: InvoiceDryRunStatus | string | null;
};

const STATUS_COLOR: Record<
  InvoiceDryRunStatus,
  'default' | 'info' | 'success' | 'warning' | 'error'
> = {
  QUEUED: 'default',
  RUNNING: 'info',
  COMPLETED: 'success',
  FAILED: 'error',
};

export default function InvoiceDryRunStatusLabel({ status }: Props) {
  const theme = useTheme();
  const normalized = String(
    status || 'QUEUED'
  ).toUpperCase() as InvoiceDryRunStatus;
  const color = STATUS_COLOR[normalized] || 'default';

  return (
    <Label
      variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
      color={color}
      sx={{ textTransform: 'capitalize' }}
    >
      {normalized.toLowerCase()}
    </Label>
  );
}
